import React from 'react';
import groupDiscussion from "../../../assets/images/groupDiscussion.png";

const GdCommence = () => {
  return (
    <div className="flex flex-1 flex-col justify-center items-center h-full w-full">
      <div className="relative w-full max-w-[536px] mobile:max-w-[90%] bg-gray-800 rounded-2xl flex items-center px-4 py-6 shadow-lg">
        <img
          src={groupDiscussion}
          alt="Group Discussion"
          className="object-contain w-12 h-12 mr-4"
          width={100}
          height={100}
        />

        <div className="flex flex-col">
          <span className="text-sm tablet:text-base laptop:text-lg desktop:text-xl font-medium text-gray-300">
            Group Discussion Setup complete!
          </span>
          <span className="text-base tablet:text-lg laptop:text-xl desktop:text-2xl text-[#E9BE50] italic font-semibold mt-1">
            Launching now...
          </span>
        </div>
      </div>
    </div>
  );
};

export default GdCommence;